import request from "@/plugin/axios";
//查询空表头（需上传表名）
export function getNullTitle(data) {
  return request({
    url: "/getNullTitle",
    method: "post",
    data: data
  });
}
//查询这个ID是否有重复 （新增时使用）
export function duplicateChecking(data) {
  return request({
    url: "/duplicateChecking",
    method: "post",
    data: data
  });
}
//查询空表头（需上传表名，laozhiqiao用）
export function getNullTitleY(data) {
  return request({
    url: "/getNullTitleY",
    method: "post",
    data: data
  });
}
//查重
export function duplicateCheckingY(data) {
  return request({
    url: "/duplicateCheckingY",
    method: "post",
    data: data
  });
}
//查语言列表
export function getlanguageList(data) {
  return request({
    url: "/getlanguageList",
    method: "post",
    data: data
  });
}
